import { useEffect, useState } from 'react';
import { reviewUserReports } from '../services/reportService';
import { getBlockCopy, getDismissCopy } from '../constants/reports';

// Confirm step for blocking a reported user or dismissing their reports.
// `target` is { user, action } or null. On success `onDone(response, target)` is called;
// on failure `onError(message)` gets the API's message. Either way the modal closes.
export default function ReportActionModal({ target, onClose, onDone, onError }) {
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setSubmitting(false);
  }, [target]);

  if (!target?.user) return null;

  const { user, action } = target;
  const copy = action === 'block' ? getBlockCopy(user.name) : getDismissCopy(user.name);

  async function handleConfirm() {
    if (submitting) return;
    setSubmitting(true);

    try {
      const response = await reviewUserReports(user.id, action);
      onDone?.(response, target);
    } catch (err) {
      onError?.(err.message || 'Failed to update reports.');
    } finally {
      onClose();
    }
  }

  return (
    <div className="modal-overlay report-action-overlay" onClick={submitting ? undefined : onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="report-action-title"
      >
        <h3 id="report-action-title" className="modal-title">{copy.title}</h3>
        <p className="modal-message">{copy.message}</p>
        <div className="modal-actions">
          <button type="button" className="modal-btn modal-btn-cancel" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button
            type="button"
            className={`modal-btn modal-btn-confirm ${action === 'block' ? 'modal-btn-danger' : ''}`}
            onClick={handleConfirm}
            disabled={submitting}
          >
            {submitting ? 'Submitting…' : copy.confirm}
          </button>
        </div>
      </div>
    </div>
  );
}
